import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  uploadDocumentation,
  getDocumentation,
  documentationDelete,
} from "../modules/actions";

const mapStateToProps = (state) => ({
  state: {
    documentation: state.documentationReducer.documentation,
    uploadingType: state.documentationReducer.loading,
  },
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      uploadDocumentation,
      getDocumentation,
      documentationDelete,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
